import React, { ReactNode } from 'react'
import { ListItem, ListItemBaseProps } from '@mui/material'

interface IProps extends ListItemBaseProps {
  children: ReactNode
}

export const BulletListItem: React.FC<IProps> = ({ children, ...props }) => {
  return (
    <ListItem {...props} sx={{ listStyleType: 'disc', display: 'list-item' }}>
      {children}
    </ListItem>
  )
}
